import _get from "lodash/get";
import { getRetailerState } from "./selectors";
import { CUSTOMER_TYPE, FORM_ID, FormId } from "../../../../../constants";
import { Form, RootState } from "../../../../../models";
import { getActiveSubscription } from "../../../checkout/state/selectors/cartSelectors";
import { getPhoneNumberCheckIsAllowedToProceed } from "../../../checkout/state/selectors/phoneNumberSelectors";

export type State = RootState;

const initialFormState: Form = { values: {}, errors: {}, visible: {}, started: {} };

export const getFormById = (state: State, id: FormId): Form => _get(getRetailerState(state), id, initialFormState);

// Add Customer Form
export const showAddCustomerInputFields = (state: State) => {
    const activeSubscription = getActiveSubscription(state);
    const form = getFormById(state, FORM_ID.CUSTOMER_PRODUCT_USER);

    const customerType = _get(form, "values.user.type", null);
    const phoneNumberCheckIsAllowedToProceed = getPhoneNumberCheckIsAllowedToProceed(state, activeSubscription);

    return (!!activeSubscription && phoneNumberCheckIsAllowedToProceed) || customerType === CUSTOMER_TYPE.NEW;
};
